import { withTranslation } from '@application/i18n/with_translation';
import { ActionCard, Flex, Spacer } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import {
	ConditionInfoScreen,
	ConditionWithInfoScreen,
	shouldShowConditionInfoScreen,
} from '@component/condition_info_screen.component';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { ReceptionConditionInfoScreenFlow } from '@visiba/api-vcs-client-v2';
import { useState } from 'react';
import { Skeleton } from '../../components/skeleton';
import { useCreateNewMessage } from '../../hooks/use-create-new-message';
import { useScreenRfv } from './use-screen-rfv';

export function ScreenRfv() {
	const { filteredReasonForVisits } = useCreateNewMessage();
	const createNewMessage = useCreateNewMessage();
	const { screenState, selectReasonForVisit } = useScreenRfv();
	const [infoScreenCondition, setInfoScreenCondition] = useState<ConditionWithInfoScreen | null>(null);

	if (infoScreenCondition) {
		return (
			<ConditionInfoScreen
				condition={infoScreenCondition}
				flow={ReceptionConditionInfoScreenFlow.Messaging}
				onBack={() => setInfoScreenCondition(null)}
				onCancel={() => createNewMessage.goToReceptionHome()}
			/>
		);
	}

	return (
		<Flex gap={tokens.spacing.x1_5}>
			<TopBar.Content goBack />

			{screenState !== 'ready' ? (
				<Skeleton />
			) : (
				<>
					<Title
						title={withTranslation('View.CreateNewMessage.ScreenRfv.Title')}
						titleSize='small'
						description={withTranslation('View.CreateNewMessage.ScreenRfv.Description')}
					/>

					<Spacer vertical={tokens.spacing.x0_5} />

					<Flex gap={tokens.spacing.x1}>
						{filteredReasonForVisits.map((reasonForVisit) => (
							<ActionCard.Root
								key={reasonForVisit.Id}
								onClick={() => {
									if (shouldShowConditionInfoScreen(reasonForVisit, ReceptionConditionInfoScreenFlow.Messaging)) {
										setInfoScreenCondition(reasonForVisit);
										return;
									}

									selectReasonForVisit(reasonForVisit.Id);
								}}
							>
								<ActionCard.Title>{reasonForVisit.Name}</ActionCard.Title>
							</ActionCard.Root>
						))}
					</Flex>
				</>
			)}
		</Flex>
	);
}
